export { createGlobalStore, createStore, HoxRoot } from 'hox';
export declare type DepsFn<T> = (model: T) => unknown[];
